<template>
	<div class="od">
		<div v-if="order_detail" class="od_1">
			<!-- 
			status
			0 待支付
			1 待确认 
			2 待使用
			3 已完成
			4 已取消
			5 已关闭 
			 -->
			<div class="od_1_1 font_weight">
				<img v-if="order_detail.status==0" src="../resource/order_4.png" alt="" />
				<img v-if="order_detail.status==1" src="../resource/order_1.png" alt="" />
				<img v-if="order_detail.status==2" src="../resource/order_1.png" alt="" />
				<img v-if="order_detail.status==3" src="../resource/order_2.png" alt="" />
				<img v-if="order_detail.status==4" src="../resource/order_3.png" alt="" />
				<img v-if="order_detail.status==5" src="../resource/order_3.png" alt="" />
				
				{{order_detail.status==0?'待支付':order_detail.status==1?'待确认':order_detail.status==2?'待使用':order_detail.status==3?'已完成':order_detail.status==4?'已取消':'已关闭'}}
			</div>
			<div v-if="order_detail.status==2" class="od_1_2">
				请在<div>{{order_detail.book_info.book_time}}</div>到店使用
			</div>
			<!-- <div v-if="order_detail.status==0" class="od_1_3">*当前订单不可再次支付，可关闭订单或重新下单。</div> -->
			<div v-if="order_detail.status==2" class="od_1_3">*距预约时间24小时前可取消订单，过时不退。</div>
		</div>
		<div v-if="order_detail" class="od_body">
			<div v-if="order_detail.status==3 || order_detail.status==4 || order_detail.status==5" class="od_2">
				<div class="od_2_1 white_space font_weight">{{order_detail.book_info.service_name}}</div>
				<div v-if="order_detail.book_info.duration" class="od_2_2 white_space">服务时长：{{order_detail.book_info.duration+'分钟'}}</div>
				<div v-if="order_detail.book_info.venue_name" class="od_2_2 white_space">场馆名称：{{order_detail.book_info.venue_name}}</div>
				<div v-if="order_detail.book_info.venue_address" class="od_2_2 white_space">场馆地址：{{order_detail.book_info.venue_address}}</div>
			</div>
			<div v-if="order_detail.status==0 || order_detail.status==1" class="od_3">
				<div class="od_3_1 white_space font_weight">{{order_detail.book_info.service_name}}</div>
				<div v-if="order_detail.book_info.duration" class="od_2_2 white_space">服务时长：{{order_detail.book_info.duration+'分钟'}}</div>
				<div v-if="order_detail.book_info.venue_name" class="od_2_2 white_space">场馆名称：{{order_detail.book_info.venue_name}}</div>
				<div v-if="order_detail.book_info.venue_address" class="od_2_2 white_space">场馆地址：{{order_detail.book_info.venue_address}}</div>
				<div class="od_3_3 font_weight">核销码</div>
				<div class="od_3_4 font_weight">********</div>
			</div>
			<div v-if="order_detail.status==2" class="od_4">
				<div class="od_4_1 white_space font_weight">{{order_detail.book_info.service_name}}</div>
				<div v-if="order_detail.book_info.duration" class="od_2_2 white_space">服务时长：{{order_detail.book_info.duration+'分钟'}}</div>
				<div v-if="order_detail.book_info.venue_name" class="od_2_2 white_space">场馆名称：{{order_detail.book_info.venue_name}}</div>
				<div v-if="order_detail.book_info.venue_address" class="od_2_2 white_space">场馆地址：{{order_detail.book_info.venue_address}}</div>
				<div class="od_4_3 font_weight">核销码</div>
				<div class="od_4_4">
					<div>
						<canvas id="qrcodeCanvas"></canvas>
						<div>{{order_detail.verify_codeM}}</div>
					</div>
				</div>
			</div>
			<div class="od_5">
				<div class="od_5_1 font_weight">预约信息</div>
				<div>
					<div class="od_5_2">
						预约人数
						<div>{{order_detail.book_info.book_num}}</div>
					</div>
					<div class="od_5_2">
						预约人
						<div>{{order_detail.book_info.book_name}} {{order_detail.book_info.book_phone}}</div>
					</div>
					<div class="od_5_2">
						预约时间
						<div>{{order_detail.book_info.book_time}}</div>
					</div>
					<!-- <div class="od_5_2">
						服务时长
						<div>{{order_detail.book_info.duration+'分钟'}}</div>
					</div> -->
				</div>
			</div>
			<div class="od_5">
				<div class="od_5_1 font_weight">
					订单信息
					<img @click="switchFold()" :class="[{'od_5_1_imgS':is_fold},'od_5_1_img']" src="../resource/back.png" alt="" />
				</div>
				<div v-if="is_fold">
					<div class="od_5_2">
						订单编号
						<div>{{order_detail.order_info.order_no}}</div>
					</div>
					<div class="od_5_2">
						下单时间
						<div>{{order_detail.order_info.create_time}}</div>
					</div>
					<div class="od_5_2">
						订单总价
						<div>¥{{order_detail.order_info.total_fee}}</div>
					</div>
					<div class="od_5_2">
						实付金额
						<div>¥{{order_detail.order_info.pay_fee}}</div>
					</div>
					<div class="od_5_2">
						支付方式
						<div>在线支付</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="order_detail && order_detail.can_cancel" class="od_6">
			<div @click="cancelOrderBefore()">取消订单</div>
		</div>
		<div v-if="order_detail && order_detail.can_close" class="od_7">
			<div @click="closeOrderBefore()" class="od_7_item_1">关闭订单</div>
			<div @click="continuePay()" class="od_7_item_2">立即支付</div>
		</div>
		<div>url={{url}}</div>
	</div>
</template>
<script>
	import naviBack from '../components/navi_back.vue';
	import {
		expEasyNumber
	} from "../lib/utils.js"
	export default {
		components: {
			naviBack
		},
		data() {
			return {
				order_detail:null,
				is_fold:true,
				url:''
			}
		},
		mounted() {
			this.url=window.location.href
			// this.$loading('正在加载中...');
			// this.getOrderDetail()
			this.getToken()
		},
		methods: {
			getToken(){
				console.log(this.$route);
			},
			getOrderDetail(){
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.order_orderDetail
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						if(res.data && res.data.verify_code){
							res.data.verify_codeM=expEasyNumber(res.data.verify_code)
						}
						$this.order_detail=res.data
						setTimeout(()=>{
							$this.$loading.close();
							$this.generateQRCode(res.data.verify_code)
						},50)
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg?error.msg:error.message);
					})
			},
			generateQRCode(url) {
				var QRCode = require('qrcode')
				var canvas = document.getElementById('qrcodeCanvas')
			
				let opts = {
					errorCorrectionLevel: "H", //容错级别
					type: "image/png", //生成的二维码类型
					margin: 3, //二维码留白边距
					width: 170, //宽
					height: 170, //高
					text: url, //二维码内容
					color: {
						dark: "#000000", //前景色
						light: "#fff" //背景色
					},
				};
				QRCode.toCanvas(canvas, url, opts, function(error) {})
				// QRCode.toCanvas(canvas1, url, opts, function(error) {})
				// QRCode.toCanvas(canvas2, url, opts, function(error) {})
			},
			switchFold(){
				this.is_fold=!this.is_fold
			},
			cancelOrderBefore(){
				var $this=this
				this.$dialog.confirm({
					title: '',
					message: '是否取消订单？',
					confirmButtonText:'取消订单',
					confirmButtonColor:'#F77F28',
				}).then(() => {
				    // on confirm
					$this.cancelOrder()
				}).catch(() => {
					// on cancel
				});
			},
			cancelOrder(){
				this.$loading('正在取消订单...');
				var $this=this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.order_orderCancel
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						$this.getOrderDetail()
						$this.$loading.close();
						$this.$toast('取消成功');
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg?error.msg:error.message);
					})
			},
			closeOrderBefore(){
				var $this=this
				this.$dialog.confirm({
					title: '',
					message: '是否关闭订单？',
					confirmButtonText:'关闭订单',
					confirmButtonColor:'#F77F28',
				}).then(() => {
				    // on confirm
					$this.closeOrder()
				}).catch(() => {
					// on cancel
				});
			},
			closeOrder(){
				this.$loading('正在关闭订单...');
				var $this=this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.order_orderClose
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						$this.getOrderDetail()
						$this.$loading.close();
						$this.$toast('关闭成功');
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg?error.msg:error.message);
					})
			},
			continuePay(){
				console.log('继续支付');
				// order_repay
				
				this.$loading('正在加载中...');
				var $this = this
				var params={}
				var qs = require('qs');
				var url = this.api.userApi.order_repay
				this.axios.post(url, qs.stringify(params))
					.then((res) => {
						console.log(res);
						// $this.page_type=2
						$this.$loading.close();
						window.location.href=res.data.url
					}).catch((error) => {
						$this.$loading.close();
						$this.$toast(error.msg?error.msg:error.message);
					})
			},
		}
	}
</script>
<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.od {
		width: 100%;
		min-height: 100vh;
		background-color: #F6F7F9;
		background-color: od;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}

	.od_1 {
		width: 100%;
		background-color: #fff;
		padding: 30*@vm_base 50*@vm_base;

		.od_1_1 {
			font-size: 36*@vm_base;
			color: #333333;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			img {
				width: 40*@vm_base;
				margin-right: 10*@vm_base;
			}
		}

		.od_1_2 {
			margin-top: 30*@vm_base;
			width: 100%;
			font-size: 28*@vm_base;
			color: #666666;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			div {
				color: #F77F28;
			}
		}

		.od_1_3 {
			width: 100%;
			font-size: 24*@vm_base;
			color: #999999;
			margin-top: 20*@vm_base;
		}
	}

	.od_body {
		width: 100%;
		padding: 0 20*@vm_base;
	}

	.od_2 {
		width: 100%;
		padding: 30*@vm_base;
		background: #FFFFFF;
		border-radius: 16*@vm_base;
		margin-top: 20*@vm_base;

		.od_2_1 {
			width: 100%;
			font-size: 30*@vm_base;
			color: #333333;
		}

		
	}
	.od_2_2 {
		width: 100%;
		font-size: 28*@vm_base;
		color: #666666;
		margin-top: 15*@vm_base;
	}
	.od_3{
		width: 100%;
		padding: 30*@vm_base;
		background: #FFFFFF;
		border-radius: 16*@vm_base;
		margin-top: 20*@vm_base;
		
		.od_3_1 {
			width: 100%;
			font-size: 30*@vm_base;
			color: #333333;
		}
		
		.od_3_2 {
			width: 100%;
			font-size: 28*@vm_base;
			color: #666666;
			margin-top: 20*@vm_base;
		}
		.od_3_3{
			width: 100%;
			font-weight: 500;
			font-size: 30*@vm_base;
			color: #333333;
			margin-top: 38*@vm_base;
			padding-top: 40*@vm_base;
			border-top: 1*@vm_base solid #D9D9D9;
		}
		.od_3_4{
			width: 100%;
			padding: 100*@vm_base 0 44*@vm_base 0;
			text-align: center;
			font-size: 50*@vm_base;
			color: #F77F28;
		}
	}
	.od_4{
		width: 100%;
		padding: 30*@vm_base;
		background: #FFFFFF;
		border-radius: 16*@vm_base;
		margin-top: 20*@vm_base;
		
		.od_4_1 {
			width: 100%;
			font-size: 30*@vm_base;
			color: #333333;
		}
		
		.od_4_2 {
			width: 100%;
			font-size: 28*@vm_base;
			color: #666666;
			margin-top: 20*@vm_base;
		}
		.od_4_3{
			width: 100%;
			font-weight: 500;
			font-size: 30*@vm_base;
			color: #333333;
			margin-top: 38*@vm_base;
			padding-top: 40*@vm_base;
			border-top: 1*@vm_base solid #D9D9D9;
		}
		.od_4_4{
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			font-size: 30*@vm_base;
			padding-bottom: 10*@vm_base;
			color: #333333;
		}
	}
	.od_5{
		width: 100%;
		padding: 30*@vm_base;
		background: #FFFFFF;
		border-radius: 16*@vm_base;
		margin-top: 20*@vm_base;
		.od_5_1{
			width: 100%;
			font-size: 30*@vm_base;
			color: #333333;
			display: flex;
			justify-content: space-between;
			align-items: center;
			img{
				width: 30*@vm_base;
			}
			.od_5_1_img{
				transform: rotateZ(-90deg);
			}
			.od_5_1_imgS{
				transform: rotateZ(90deg);
			}
		}
		.od_5_2{
			width: 100%;
			font-size: 28*@vm_base;
			color: #666;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			margin-top: 30*@vm_base;
			white-space: nowrap;
			div{
				color: #333333;
				text-align: right;
				white-space: pre-wrap;
			}
		}
	}
	.od_6{
		width: 100%;
		padding: 60*@vm_base 0;
		div{
			width: fit-content;
			white-space: nowrap;
			border: 1*@vm_base solid #999999;
			border-radius: 16*@vm_base;
			padding: 15*@vm_base 20*@vm_base;
			font-size: 28*@vm_base;
			margin: 0 auto;
			color: #666;
		}
	}
	.od_7{
		width: 100%;
		padding: 60*@vm_base 0;
		display: flex;
		justify-content: center;
		align-items: center;
		.od_7_item_1{
			width: fit-content;
			white-space: nowrap;
			border: 1*@vm_base solid #999999;
			border-radius: 16*@vm_base;
			padding: 15*@vm_base 20*@vm_base;
			font-size: 28*@vm_base;
			margin: 0 30*@vm_base;
			color: #666;
		}
		.od_7_item_2{
			width: fit-content;
			white-space: nowrap;
			border: 1*@vm_base solid #F77F28;
			background: #F77F28;
			border-radius: 16*@vm_base;
			padding: 15*@vm_base 20*@vm_base;
			font-size: 28*@vm_base;
			margin: 0 30*@vm_base;
			color: #fff;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/tranform_3.vue